import { Modal } from 'src/modules/common/components/Modal/Modal.tsx';
import { ModalHeader } from 'src/modules/common/components/Modal/ModalHeader.tsx';
import { ModalBody } from 'src/modules/common/components/Modal/ModalBody.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { I18n } from 'src/modules/common/components/I18n/I18n';

export const ErrorModal = () => (
    <Modal opened={true} size="sm" handleClose={() => null} danger={true}>
        <ModalHeader title={MESSAGES.somethingWrongModalSubtitle}/>

        <ModalBody>
            <div className="vss-error-modal">
                <p className="vss-error-modal__message">
                    <I18n messageId={MESSAGES.somethingWrongModalMessage}/>
                </p>
            </div>
        </ModalBody>
    </Modal>
);
